import { GitBranch, Package, FlaskConical, Wrench, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { site } from "../content/site";

const plannedIcons = [GitBranch, Wrench, FlaskConical];

export const OpenSource = () => {
  const os = site.openSource;
  const mailto = `mailto:${site.email}?subject=${encodeURIComponent("Open source interest — votanphuoc.space")}`;

  return (
    <section id="open-source" data-testid="open-source-section" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-teal-700 bg-teal-50 border border-teal-200/60 px-3 py-1.5 rounded-full inline-block">
            {os.eyebrow}
          </p>
          <h2 className="mt-6 font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
            {os.heading}
          </h2>
          <p
            data-testid="open-source-roadmap-badge"
            className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-sky-800 bg-sky-50 border border-sky-200/70 px-4 py-2 rounded-full"
          >
            <span aria-hidden="true" className="w-2 h-2 rounded-full bg-sky-500 animate-pulse" />
            {os.badge}
          </p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-5 lg:gap-6">
          <Reveal>
            <div className="h-full bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
              <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-slate-900">
                {os.why.title}
              </h3>
              <p className="mt-4 text-base text-slate-600 leading-relaxed">{os.why.text}</p>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="h-full bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
              <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-slate-900 flex items-center gap-3">
                <Package size={22} className="text-teal-600" />
                {os.planned.title}
              </h3>
              <ul className="mt-5 space-y-4">
                {os.planned.items.map((item, i) => {
                  const Icon = plannedIcons[i];
                  return (
                    <li key={item} className="flex gap-3.5 text-sm sm:text-base text-slate-600 leading-relaxed">
                      <Icon size={18} className="mt-1 shrink-0 text-teal-600" aria-hidden="true" />
                      {item}
                    </li>
                  );
                })}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="mt-6 rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-6 justify-between">
            <p data-testid="open-source-status-note" className="text-sm sm:text-base text-slate-600 leading-relaxed max-w-3xl">
              {os.status}
            </p>
            <a
              href={mailto}
              data-testid="open-source-interest-link"
              className="shrink-0 inline-flex items-center gap-2 bg-white hover:bg-slate-50 text-slate-800 font-semibold px-6 py-3 rounded-full border border-slate-300 transition-all duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2"
            >
              <Mail size={16} className="text-teal-600" />
              {os.ctaLabel}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
